import { ComponentProps } from 'react'

import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { PinInput } from '@cash-web/shared-feature-form'

import { BaseBlocker, SubmitButton } from '../../BaseBlocker/BaseBlocker'

export type BlockerPasscodeEntryProps = {
  length: number
  name: string
  onSubmit: (passcode: string) => void
  validatePin?: ComponentProps<typeof PinInput>['validatePin']
} & Omit<ComponentProps<typeof BaseBlocker>, 'onSubmit'>

export const BlockerPasscodeEntry = ({
  length,
  name,
  onSubmit,
  validatePin,
  buttons = [],
  ...rest
}: BlockerPasscodeEntryProps) => {
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  if (isArcadeMigrationEnabled) {
    return (
      <BaseBlocker
        onSubmit={onSubmit}
        buttons={buttons.length === 0 ? [<SubmitButton key="submit-passcode" />] : buttons}
        {...rest}
      >
        <PinInput name={name} pinLength={length} onComplete={onSubmit} validatePin={validatePin} />
      </BaseBlocker>
    )
  }

  return (
    <BaseBlocker onSubmit={onSubmit} buttons={buttons} {...rest}>
      <PinInput name={name} pinLength={length} onComplete={onSubmit} validatePin={validatePin} />
    </BaseBlocker>
  )
}
